import {Injectable} from '@angular/core';
import {HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {AuthService} from './login/auth.service';
import {Router} from '@angular/router';
import * as NProgress from 'nprogress';
import {environment} from '../../environments/environment';

@Injectable()
export class AddHeaderInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService, private router: Router) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const serverurl = environment.serverUrl;
    const loaderexceptionurl = [
      '/academics/academicyear/',
      '/academics/academicyearactive/',
      
      '/academicactivites/getuserassignment/',
      '/academicactivites/getstudentdiary/',
      '/academicactivites/studentassignment_markentry/?id=',

      '/communications/chat/',
      '/communications/markasread/',
      '/communications/userclass/',
      '/communications/chat_getchatusers/?classid=${classid}',
      '/communications/chat_getteacherclasses/',

      '/datatable_json/',

      '/dashboard/cpumemoryusage/',
      '/dashboard/customizewidgets/',
      '/dashboard/dashboard_acl_two_level/',
      '/dashboard/dashboard_menus/',
      '/dashboard/diskusage/',
      '/dashboard/faviconupload/',
      '/dashboard/generalsetting/',
      '/dashboard/getmobileappsettings/',
      '/dashboard/get_mobile_menus/',
      '/dashboard/get_adminwidgets/',
      '/dashboard/get_feewidget_parent/',
      '/dashboard/get_guagegraphwidget_parent/',
      '/dashboard/roles/',
      '/dashboard/get_studentwidgets_parent/',
      '/dashboard/get_superadminwidgets/',
      '/dashboard/get_teacherwidgets/',
      '/dashboard/get_userwidgets/',
      '/dashboard/mobile_user_roles/',
      '/dashboard/language/',
      '/dashboard/post_mobile_menu/',
      '/dashboard/querystudentsbyterm/',
    

      '/exammanagement/get_question_options/',
      '/exammanagement/get_question_order/',
      '/exammanagement/listcreateanswer/',
      '/exammanagement/questionoptions/',
      '/exammanagement/questions/',
      
      '/events/currentquotes/',

      '/home/homepage/dashboard/',

      '/mobileapi/get_social_feeds/',
      '/mobileapi/like_or_unlike_feeds/',


      '/notifications/notifications/',

      '/parent/parent_students/',
      '/parent/querystudentsbyterm/',

      '/paymentgateway/payment_form/',
      
      '/reports/attendance_heatmap/',
      '/reports/subjectwiseparentreport/',
      '/reports/termwisereports/',
      '/reports/termwise_topstudents/',
      '/reports/teacherattendancegraph/',
      '/reports/teachersubjectwisegraph/',
      '/reports/teachertermwisegraph/',

      '/schoolsettings/academic_year/',

      '/sharedocuments/get_subjects/',
      '/sharedocuments/get_documents/',
      
      '/socialfeeds/feed/',
      
      '/systemconfig/getactiveorganization/',
      '/systemconfig/get_users/',
      
      '/timetable/teacherview/',

      '/topics/studentsyllabusgraph/',
      '/topics/syllabusgraph/',
      
      '/transportation/transportation_fees_direct/',
      '/transportation/get_bus_location/',
      '/transportation/get_parent_student_transportation/',
      
      '/usermanagement/getuserprofile/',
      
      '/videoplay/create_video_upload/',
      '/videoplay/upload_video/',
    ];

    // add api url for every request
    // https://api.helpservice.xyz
    req = req.clone({url: serverurl + req.url});

    // add authorization header with jwt token if available
    const idToken = localStorage.getItem('token');
    if (idToken) {
      req = req.clone({
        headers: req.headers.set('Authorization', 'Token ' + idToken)
      });
    }
    const overlayElement = document.getElementById('overlay');
    // don't show spinner if on chat window.

    const req_url = req.url.split('?')[0];
    if (loaderexceptionurl.findIndex(element => req_url.includes(element)) === -1) {
      // Spinner, Loader and Overlay
      NProgress.configure({showSpinner: false});
      NProgress.start();
      if (overlayElement) {
        overlayElement.style.display = 'block';
      }
      // End of Spinner, Loader and Overlay
    }
    return next.handle(req).pipe(
      catchError(err => {
        if (err.status === 503) {
          // site is under maintenance
          this.auth.logout();
          this.router.navigate(['/errors/maintenance/']);
        } else if (err.status === 401) {
          // auto logout if 401 response returned from api
          // this.authenticationService.logout();
          this.auth.logout();
          location.reload();
        }
        // const error = err.error.message || err.statusText;
        return throwError(err);
      }),
      tap((event: HttpEvent<any>) => {
          // https://medium.com/@zeljkoradic/loader-bar-on-every-http-request-in-angular-6-60d8572a21a9
          if (event instanceof HttpResponse) {
            NProgress.done();
            if (overlayElement) {
              overlayElement.style.display = 'none';
            }
          }
        },
        (err: any) => {
          NProgress.done();
          if (overlayElement) {
            overlayElement.style.display = 'none';
          }
        }
      )
    );
  }
}
